import React, { useEffect, useState } from 'react';
import Container from '../../Container/Container';
import { get, post, put, DELETE } from '../../ApiServices/ApiServices'; // Assuming you have these methods
import { toast, ToastContainer } from 'react-toastify';
import DeleteButton from '../Component/DeleteFun';

export default function EmailAlertSettings() {
    const [showModal, setShowModal] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [emailAlert, setEmailAlert] = useState([]);
    const [modalSubmitting, setModalSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        email: '',
        dropShipping: false,
        extendedRental: false,
        status: 'Active'
    });

    const [editingId, setEditingId] = useState(null);

    // Fetch email alerts
    const ViewEmailAlert = async () => {
        try {
            setIsInitialLoading(true);
            const api = `email-alerts`;
            const totalData = await get(api);

            if (totalData?.status === true) {
                setEmailAlert(totalData?.data || [])
            }
        } catch (err) {
            console.error('Error fetching email alerts:', err);
        } finally {
            setIsInitialLoading(false);
        }
    };

    useEffect(() => {
        ViewEmailAlert()
    }, [])

    const handleAddEmail = () => {
        setFormData({
            email: '',
            dropShipping: false,
            extendedRental: false,
            status: 'Active'
        });
        setEditingId(null);
        setShowModal(true);
    };

    const handleEdit = (notification) => {
        try {
            // Parse notification_types if it's a string
            const notificationTypes = typeof notification.notification_types === 'string'
                ? JSON.parse(notification.notification_types)
                : notification.notification_types || [];

            setFormData({
                email: notification.email || '',
                dropShipping: notificationTypes.includes('Drop Shipping'),
                extendedRental: notificationTypes.includes('Extended Rental'),
                status: notification.status || 'Active'
            });
            setEditingId(notification.id);
            setShowModal(true);
        } catch (error) {
            console.error('Error parsing notification types:', error);
            setFormData({
                email: notification.email || '',
                dropShipping: false,
                extendedRental: false,
                status: notification.status || 'Active'
            });
            setEditingId(notification.id);
            setShowModal(true);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.email) {
            toast.error('Please enter an email address', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            // alert('Please enter an email address');
            return;
        }

        if (!formData.dropShipping && !formData.extendedRental) {
            toast.error('Please select at least one notification type', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            return;
        }

        setModalSubmitting(true);

        try {
            // Prepare notification types array
            const notificationTypes = [];
            if (formData.dropShipping) notificationTypes.push('Drop Shipping');
            if (formData.extendedRental) notificationTypes.push('Extended Rental');

            const payload = {
                email: formData.email,
                notification_types: notificationTypes,
                status: formData.status
            };

            let response;

            if (editingId) {
                // Update existing email alert
                response = await put(`email-alerts/${editingId}`, payload);
            } else {
                // Create new email alert
                response = await post('email-alerts', payload);
            }

            if (response?.status === true) {
                // Refresh the list
                await ViewEmailAlert();

                setShowModal(false);
                setFormData({
                    email: '',
                    dropShipping: false,
                    extendedRental: false,
                    status: 'Active'
                });
                setEditingId(null);
                toast.success(response?.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });

                // alert(editingId ? 'Email updated successfully' : 'Email added successfully');
            } else {
                toast.error(response?.message || 'Failed to update profile', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
            }
        } catch (err) {
            toast.error(err?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
        } finally {
            setModalSubmitting(false);
        }
    };

    const closeModal = () => {
        if (!modalSubmitting) {
            setShowModal(false);
            setFormData({
                email: '',
                dropShipping: false,
                extendedRental: false,
                status: 'Active'
            });
            setEditingId(null);
        }
    };

    const getNotificationTypes = (notification) => {
        try {
            if (!notification.notification_types) return [];

            if (typeof notification.notification_types === 'string') {
                return JSON.parse(notification.notification_types);
            }

            return notification.notification_types;
        } catch (error) {
            console.error('Error parsing notification types:', error);
            return [];
        }
    };

    const toggleStatus = () => {
        setFormData({
            ...formData,
            status: formData.status === 'Active' ? 'Inactive' : 'Active'
        });
    };

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">

                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between" >
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Email Alert Settings</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <button className="btn btn-primary" onClick={handleAddEmail}>
                                            Add Email
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-header">
                                    <h5 className="card-title">Notification Emails</h5>
                                </div>
                                <div className="card-body">
                                    {isInitialLoading ? (
                                        <div className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Email</th>
                                                        <th scope="col">Notification Types</th>
                                                        <th scope="col">Status</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {emailAlert.length > 0 ? (
                                                        emailAlert.map((notification) => {
                                                            const notificationTypes = getNotificationTypes(notification);

                                                            return (
                                                                <tr key={notification.id}>
                                                                    <td data-label="Email">{notification.email}</td>
                                                                    <td data-label="Notification Types">
                                                                        {notificationTypes.map((type, index) => (
                                                                            <span
                                                                                key={index}
                                                                                className="badge bg-primary me-1"
                                                                            >
                                                                                {type}
                                                                            </span>
                                                                        ))}
                                                                    </td>

                                                                    <td data-label="Status">
                                                                        <span className={`badge ${notification.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                                                                            {notification.status}
                                                                        </span>
                                                                    </td>

                                                                    <td data-label="Action" className="tableActionBtn">


                                                                        <button className="editPen" onClick={() => handleEdit(notification)}>
                                                                            <em className="icon ni ni-edit-alt"></em>
                                                                        </button>

                                                                        <DeleteButton
                                                                            url={`/email-alerts/${notification.id}`}
                                                                            onDeleteSuccess={ViewEmailAlert}
                                                                        />

                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center py-4">
                                                                <div className="data-not-found">
                                                                    <div className="icon">ℹ️</div>
                                                                    <p>No email addresses found</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal for Create/Edit Email */}
                            {showModal && (
                                <div className="modal fade show" style={{ display: "block", backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    {editingId ? 'Edit Notification Email' : 'Add Notification Email'}
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="close"
                                                    onClick={closeModal}
                                                    disabled={modalSubmitting}
                                                >
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <form onSubmit={handleSubmit}>
                                                <div className="modal-body">
                                                    {/* Email Address Section */}
                                                    <div className="mb-4">
                                                        <label className="form-label fw-semibold d-block mb-2">Email Address</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="Enter email address"
                                                            value={formData.email}
                                                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                                            required
                                                            disabled={modalSubmitting}
                                                        />
                                                    </div>

                                                    {/* Select Notification Types Section */}
                                                    <div className="mb-4">
                                                        <label className="form-label fw-semibold d-block mb-2">Select Notification Types</label>
                                                        <div className="d-flex flex-column">
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                                    Drop Shipping
                                                                </span>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={formData.dropShipping}
                                                                    onChange={(e) => setFormData({ ...formData, dropShipping: e.target.checked })}
                                                                    id="dropShipping"
                                                                    disabled={modalSubmitting}
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        margin: 0,
                                                                        marginRight: '165px'
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                                    Extended Rental
                                                                </span>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={formData.extendedRental}
                                                                    onChange={(e) => setFormData({ ...formData, extendedRental: e.target.checked })}
                                                                    id="extendedRental"
                                                                    disabled={modalSubmitting}
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        margin: 0,
                                                                        marginRight: '165px'
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <span style={{ fontSize: '15px' }}>
                                                                    {formData.status} <span style={{ marginLeft: '15px', fontWeight: '600' }}>Status</span>
                                                                </span>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={formData.status === 'Active'}
                                                                    onChange={toggleStatus}
                                                                    id="activeStatus"
                                                                    disabled={modalSubmitting}
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        margin: 0,
                                                                        marginRight: '165px'
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div>

                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={closeModal}
                                                        disabled={modalSubmitting}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        disabled={modalSubmitting}
                                                    >
                                                        {modalSubmitting ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                                {editingId ? 'Updating...' : 'Adding...'}
                                                            </>
                                                        ) : (
                                                            editingId ? 'Update Email' : 'Add Email'
                                                        )}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}